(function(){
  /* The wordmark, read as a face.
     Tapping or clicking PABLO BORRA-PALEY on the shop page sends every letter
     to a place on a face: the two O's become the eyes, the R's the brows, the
     A of BORRA the nose, the hyphen the mouth, and the ten remaining letters
     ring the head. The eyes blink twice, the face holds, and the letters walk
     back into the wordmark. */
  var mark=document.querySelector('.mark[data-pbp-face]');
  if(!mark)return;
  var mq=window.matchMedia;
  if(mq&&mq('(prefers-reduced-motion: reduce)').matches)return;

  var ASSEMBLE=1000,STAGGER=22,RETURN=880;
  var busy=false,chars=null,timers=[];

  function wait(fn,at){ timers.push(setTimeout(fn,at)); }

  /* Keyed letter by letter to the wordmark: P A B L O _ B O R R A - P A L E Y */
  var ROLES={4:'eyeL',5:'gap',7:'eyeR',8:'browL',9:'browR',10:'nose',11:'mouth'};

  function build(){
    if(chars)return;
    var text=(mark.textContent||'').trim();
    var ls=parseFloat(getComputedStyle(mark).letterSpacing)||0;
    var frag=document.createDocumentFragment();
    chars=[];
    for(var i=0;i<text.length;i++){
      var ch=text.charAt(i);
      var s=document.createElement('span');
      s.className='fch';
      s.textContent=ch===' '?'\u00a0':ch;
      /* Tracking moves off letter-spacing (which pads the right of every box,
         throwing the ink off centre once a glyph is stretched) and onto a
         margin, so each box stays centred on its own ink. */
      s.style.letterSpacing='0';
      s.style.marginRight=ls+'px';
      frag.appendChild(s);
      chars.push(s);
    }
    mark.textContent='';
    mark.appendChild(frag);
  }

  /* Targets are measured from the untransformed layout box (offsetLeft /
     offsetTop), so a second tap plans from the wordmark, not from wherever
     the last face left the letters. The head is sized to the room actually
     available, which is what makes it fit a phone as well as a desktop. */
  function plan(){
    var k=(parseFloat(getComputedStyle(mark).fontSize)||14)/14;
    var box=mark.getBoundingClientRect();
    var room=Math.max(120,Math.min(window.innerWidth-16,document.documentElement.clientWidth-16));
    var half=Math.min(146*k,(room-box.left-8)/2,room/2-8);
    var rx=half*0.88,ry=rx*1.12,cx=half+2,cy=1.6*rx+40*k,f=rx/(128*k);
    var ring=0;
    chars.forEach(function(el,i){ if(!ROLES[i])ring++; });
    var step=ring?360/ring:36,ri=0,out=[];
    chars.forEach(function(el,i){
      var role=ROLES[i],t;
      if(role==='gap'){ out.push({el:el,hide:true}); return; }
      if(role==='eyeL')       t={x:cx-60*k*f,y:cy-34*k*f,rot:0,sx:3.6*f,sy:3.6*f};
      else if(role==='eyeR')  t={x:cx+60*k*f,y:cy-34*k*f,rot:0,sx:3.6*f,sy:3.6*f};
      else if(role==='browL') t={x:cx-60*k*f,y:cy-80*k*f,rot:-14,sx:1.7*f,sy:1*f};
      else if(role==='browR') t={x:cx+60*k*f,y:cy-80*k*f,rot:14,sx:1.7*f,sy:1*f};
      else if(role==='nose')  t={x:cx,y:cy+26*k*f,rot:0,sx:2.1*f,sy:2.1*f};
      else if(role==='mouth') t={x:cx,y:cy+84*k*f,rot:0,sx:20*f,sy:2.2*f};
      else{
        var deg=-90+ri*step; ri++;
        var a=deg*Math.PI/180;
        /* Letters lie along the curve, but never upside down. */
        var rot=deg+90,w=((rot%360)+360)%360;
        if(w>90&&w<270)rot+=180;
        t={x:cx+rx*Math.cos(a),y:cy+ry*Math.sin(a),rot:rot,sx:1.4*f,sy:1.4*f};
      }
      var ox=el.offsetLeft+el.offsetWidth/2;
      var oy=el.offsetTop+el.offsetHeight/2;
      out.push({el:el,role:role,tf:'translate('+(t.x-ox).toFixed(1)+'px,'+(t.y-oy).toFixed(1)+'px) rotate('+t.rot.toFixed(1)+'deg) scale('+t.sx.toFixed(2)+','+t.sy.toFixed(2)+')'});
    });
    return out;
  }

  function run(){
    var list=plan(),n=list.length,eyes=[];

    list.forEach(function(o,i){
      o.el.style.transition='';
      o.el.style.transitionDelay=(i*STAGGER)+'ms';
      o.el.style.transitionDuration=ASSEMBLE+'ms';
      if(o.hide){ o.el.style.opacity='0'; return; }
      o.el.style.transform=o.tf;
      if(o.role==='eyeL'||o.role==='eyeR')eyes.push({el:o.el,base:o.tf});
    });

    function blink(at){
      eyes.forEach(function(e){
        wait(function(){
          e.el.style.transitionDelay='0ms';
          e.el.style.transitionDuration='90ms';
          e.el.style.transform=e.base+' scaleY(.05)';
        },at);
        wait(function(){
          e.el.style.transitionDuration='130ms';
          e.el.style.transform=e.base;
        },at+170);
      });
    }

    var settled=ASSEMBLE+n*STAGGER+300;
    blink(settled);
    blink(settled+540);

    var back=settled+540+300+900;
    list.forEach(function(o,i){
      wait(function(){
        o.el.style.transitionDelay='0ms';
        o.el.style.transitionDuration=RETURN+'ms';
        o.el.style.transform='';
        o.el.style.opacity='';
      },back+(n-1-i)*18);
    });
    wait(function(){ busy=false; },back+n*18+RETURN+80);
  }

  mark.addEventListener('click',function(e){
    e.preventDefault();
    if(busy)return;
    busy=true;
    timers.forEach(clearTimeout);
    timers=[];
    build();
    run();
  });
})();
